const linkdin = 'https://www.linkedin.com/in/VedantAchharya';
const twitter =
  'https://twitter.com/PHANTOMGOD_DEV?t=oyLCf11c7cTagQmtV8plZw&=09';
const github = 'https://github.com/PHANTOMGOD2OP';
const instagram = 'https://www.instagram.com/phantomgod_vedant/';
const discordserver = 'https://discord.gg/swdEMTXyGk';
const email = 'mailto:phantom.god.dev@gmail.com';
const discord = 'https://discord.com/users/720324352855244866';
const youtube = 'https://www.youtube.com/channel/UCRE1zPOnZj4332YFLXRu1ag';
const chess = 'https://chess.com/member/PHANTOMGOD_CHESS';
const resume = '';
export default {
  linkdin,
  twitter,
  github,
  instagram,
  discord,
  discordserver,
  email,
  youtube,
  chess,
  resume,
};
